<template>
  <div>
    <div v-if="isLoggedIn">
      <slot
        name="authenticated"
        v-bind="{wallet, displayName}"
      >
        <wallet-profile
          no-overlay
          :wallet="wallet"
        />
      </slot>
    </div>
    <button
      v-else
      v-tooltip="'Connect with your wallet'"
      class="w-10 h-10 bg-indigo-500 rounded-full opacity-90 hover:opacity-100"
      @click="eventBus.$emit('auth:signIn')"
    >
      <i class="fas fa-wallet" />
    </button>
  </div>
</template>

<script>
import WalletProfile from "@/components/wallets/WalletProfile";
import {mapGetters, mapState} from 'vuex';
import UiButton from "@/components/ui/UiButton";
import eventBus from "@/utils/event-bus";

export default {
  name: "UserProfile",

  components: {UiButton, WalletProfile},

  data() {
    return {
      eventBus,
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
    }),
    wallet() {
      return this.user.wallets[0];
    },
    displayName() {
      return this.wallet?.openseaProfile?.username || this.wallet?.name || this.wallet?.id.slice(0, 6);
    },
  }
}
</script>

<style scoped>

</style>
